export interface PricingCardStaticDetailsTypes {
  topSectionImg: string;
  bgColor: string;
  offerHeading: string;
  additionInfo: {
    icon: string;
    fontColor: string;
    text: string;
  };
}
export const PricingCardStaticDetails: PricingCardStaticDetailsTypes[] = [
  {
    topSectionImg:
      'https://assets.clear.in/cleartax/images/1746783266_group1814222392.svg',
    bgColor:
      'radial-gradient(82.39% 75.05% at 17.61% -1.19%, rgba(215, 213, 213, 0.6) 0%, rgba(255, 255, 255, 0.3) 77.89%, rgba(255, 255, 255, 0.3) 98.19%)',
    offerHeading: 'offer price (inclusive of taxes)',
    additionInfo: {
      icon: 'https://assets.clear.in/cleartax/images/1746783859_group1814222390.svg',
      fontColor: '#4B5159',
      text: 'Direct call with tax expert and Q&A session',
    },
  },
  {
    topSectionImg:
      'https://assets.clear.in/cleartax/images/1746784778_group1814222393.svg',
    bgColor:
      'radial-gradient(134.28% 128.19% at -50.22% -44.57%, #CDBBF4 9.22%, #F4F0FE 55.08%, rgba(255, 255, 255, 0.3) 88.68%) ',
    offerHeading: 'offer price (inclusive of taxes)',
    additionInfo: {
      fontColor: '#6469E4',
      icon: 'https://assets.clear.in/cleartax/images/1746783790_group1814222391.svg',
      text: 'Live Video filing and Q&A session with tax experts',
    },
  },

  {
    topSectionImg:
      'https://assets.clear.in/cleartax/images/1746784824_group1814222396.svg',
    bgColor:
      'radial-gradient(82.39% 75.05% at 17.61% -1.19%, rgba(255, 233, 176, 0.5) 0%, rgba(255, 255, 255, 0.3) 77.89%, rgba(255, 255, 255, 0.3) 98.19%)',
    offerHeading: 'offer price (inclusive of taxes)',
    additionInfo: {
      icon: 'https://assets.clear.in/cleartax/images/1746015599_group18142223911.png',
      fontColor: '#E8743E',
      text: 'Live Video filing + Q&A session + video assistance for tax planning in the year',
    },
  },
];
